
import Dialog from '../../../../../../../../../../../../BaseComponents/Dialog/EDDialog';
import EkonomiskAnalysEditColumn from '../../EkonomiskAnalysEditColumn';
import { ekanalys_ekanalys_columns } from '../../../../../../../Queries/EkonomiskAnalysSettingsQuery/_QueryTypes/ekanalys';
import EkonomiskAnalysEditColumnForm, {
  EkonomiskAnalysEditColumnFormValuesType,
} from '../EkonomiskAnalysEditColumnForm';
import EkonomiskAnalysStandardColumnQuery from '../Queries/EkonomiskAnalysStandardColumnQuery/EkonomiskAnalysStandardColumnQuery';
import EkonomiskAnalysEditColumnManualCaptionQuery from '../Queries/EkonomiskAnalysEditColumnCaptionQuery/EkonomiskAnalysEditColumnManualCaptionQuery';
import { IEkonomiskAnalysDates } from '../../../../../../AnalysSettingsHandler/AnalysSettingsHandler';
import EkonomiskAnalysEditColumnReferencePeriod from '../EkonomiskAnalysEditColumnReferencePeriod/EkonomiskAnalysEditColumnReferencePeriod';
import { findStandardColumnByFaltkod } from '../../Utils/EkonomiskAnalysEditColumnUtils';
import { getDefaultDate } from '../../../../../../../../../../../../Utils/dateUtils';
import { getDateInputType } from '../../../../../../../Utils/analysUtils';
import { editColumnFormValuesToColumn } from '../../Utils/EkonomiskAnalysConvertEditColumnFormValuesToColumn';

interface IProps {
  title: string;
  open: boolean;
  codePrivilegeId: string;
  analysName: string;
  close: () => void;
  onExited?: () => void;
  column: ekanalys_ekanalys_columns;
  setColum: (
    newColumn: ekanalys_ekanalys_columns,
    newName: string,
    newDisplayLabel: string
  ) => void;
  dates: IEkonomiskAnalysDates;
  isInterval: boolean;
  isNewColumn: boolean;
}

export interface INewColumnData {
  codePrivilegeId: string;
  dates: IEkonomiskAnalysDates;
  isInterval: boolean;
}

/**
 * En dialog där värden för en kolumn kan ändras
 */
const EkonomiskAnalysEditColumnDialog: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const newColumnData: INewColumnData = {
    codePrivilegeId: props.codePrivilegeId,
    dates: props.dates,
    isInterval: props.isInterval,
  };

  return (
    <EkonomiskAnalysStandardColumnQuery>
      {({ standardColumns }) => (
        <EkonomiskAnalysEditColumnManualCaptionQuery
          newColumnData={newColumnData}
        >
          {getColumnDisplayLabel => (
            <EkonomiskAnalysEditColumnForm
              column={props.column}
              setColumn={props.setColum}
              dates={props.dates}
              standardColumns={standardColumns || []}
              getColumnDisplayLabel={getColumnDisplayLabel}
            >
              {({ values, submitForm, setFieldValue }) => {
                const formValues =
                  values as EkonomiskAnalysEditColumnFormValuesType;
                return (
                  <>
                    <Dialog
                      open={props.open}
                      title={`${
                        props.isNewColumn ? 'Lägg till' : 'Redigera'
                      } enskild kolumn`}
                      onClose={props.close}
                      maxWidth="sm"
                      fullWidth
                      footerActions={[
                        { label: 'Avbryt', onClick: props.close },
                        {
                          label: 'Använd',
                          onClick: submitForm,
                          buttonProps: { disabled: !formValues.columnOrigin },
                        },
                      ]}
                      subtitle={
                        <EkonomiskAnalysEditColumnReferencePeriod
                          dates={getDefaultDate(
                            props.dates,
                            getDateInputType(
                              [
                                {
                                  name: '',
                                  id: 0,
                                  data: editColumnFormValuesToColumn(
                                    formValues,
                                    props.column,
                                    standardColumns ?? [],
                                    props.dates
                                  ),
                                },
                              ],
                              standardColumns
                            )
                          )}
                          isInterval={
                            findStandardColumnByFaltkod(
                              formValues.columnOrigin,
                              standardColumns
                            )?.TOMAR ?? false
                          }
                        />
                      }
                      onExited={props.onExited}
                    >
                      <EkonomiskAnalysEditColumn
                        formValues={formValues}
                        setFieldValue={setFieldValue}
                        initialColumn={props.column}
                        newColumnData={newColumnData}
                      />
                    </Dialog>
                  </>
                );
              }}
            </EkonomiskAnalysEditColumnForm>
          )}
        </EkonomiskAnalysEditColumnManualCaptionQuery>
      )}
    </EkonomiskAnalysStandardColumnQuery>
  );
};

export default EkonomiskAnalysEditColumnDialog;
